import React, { useState } from 'react';
import currency from 'currency.js';
import { AddonSheet } from '../../../../models';
import cn from 'classnames';
import { addonSheetToSheet } from '../../../PackageBuilders/MultiPose/functions';
import DisplayableSheet from '../../../PackageBuilders/MultiPose/DisplayableSheet';
import IncrementalButton from '../../../PackageBuilders/IndividualPrintsBuilder/IncrementalButton';
import Button from '../../../Button/v2';
import styles from '../../../PackageBuilders/IndividualPrintsBuilder/IndividualPrintsBuilder.module.scss';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { determineBackground } from './utils';
import { ItemSubtitle, isAnnouncement } from './ItemAdder';
import { grantsFreeAnnouncements } from '../../../../utils/offerPricing';

export default function ItemBuilder({
                                      addons,
                                      background,
                                      backgrounds,
                                      isLoading,
                                      isWithoutPackage = true,
                                      initialItems = [],
                                      isSiblingPose = false,
                                      pose,
                                      selectedAddonType,
                                      offer = null,
                                      onConfirm,
                                      onCancelProps = {},
                                    }) {
  // const displayCancelButton = Object.keys(onCancelProps).length > 0;
  const displayCancelButton = false;

  const [printBuilderCart, setPrintBuilderCart] = useState({});
  const [hasMadeSelection, setHasMadeSelection] = useState(false);

  const handleDecrement = (addonId) => {
    const currValue = printBuilderCart[addonId] ? printBuilderCart[addonId] : 0;
    setPrintBuilderCart((prev) => ({ ...prev, [addonId]: Math.max(currValue - 1, 0) }));
    setHasMadeSelection(true);
  };

  const handleIncrement = (addonId) => {
    const currValue = printBuilderCart[addonId] ? printBuilderCart[addonId] : 0;
    setPrintBuilderCart((prev) => ({ ...prev, [addonId]: currValue + 1 }));
    setHasMadeSelection(true);
  };

  const continueText = (addon) => {
    if (addon?.backgroundSelection) {
      return 'Select Backgrounds and Customize'
    }

    return 'Customize'
  }

  // const sheets = addons.map((addon) => addonSheetToSheet(new AddonSheet({ addon, background, pose })));
  const sheets = addons.map((addon) => addonSheetToSheet({ addon, background, pose }));

  const totalItems = Object.keys(printBuilderCart).reduce((acc, cur) => acc + printBuilderCart[cur], 0);

  const handleConfirm = () => {
    const addonSheets = Object.keys(printBuilderCart).map((id) => (
      new Array(printBuilderCart[id]).fill(null).map(() => {
        const addon = addons.find((addon) => addon.id.toString() === id.toString());

        const addonSheet = ({
          addon,
          addonId: addon.id,
          background,
          backgroundId: background.id,
          pose,
          poseId: pose.id,
        });


        const bg = determineBackground(addonSheet, backgrounds);
        return { ...addonSheet, background: bg, backgroundId: bg.id };
      })
    )).flat();

    onConfirm(addonSheets);
  };

  useDeepCompareEffect(() => {
    // Don't clobber in-progress selections: `offer` resolves asynchronously, so
    // once the customer has touched quantities (or we've pre-selected the free
    // bundle), a late offer/addons change must not reset printBuilderCart.
    if (hasMadeSelection) return;

    const nextState = initialItems.reduce((acc, cur) => {
      const count = acc[cur.addonId] || 0;

      return { ...acc, [cur.addonId]: count + 1 };
    }, {});

    // Pre-select the free bundle: when the offer includes a free announcement,
    // default one announcement to quantity 1 (and enable Continue) so the
    // customer gets their free bundle without having to add it themselves.
    if (Object.keys(nextState).length === 0 && grantsFreeAnnouncements(offer)) {
      const freeAddon = addons.find(isAnnouncement);
      if (freeAddon) {
        nextState[freeAddon.id] = 1;
        setHasMadeSelection(true);
      }
    }

    setPrintBuilderCart(nextState);
  }, [initialItems, addons, offer]);

  return (
    <>
      <div className={cn(styles.container, { [styles.cancelBtn]: displayCancelButton, isSiblingPose }, selectedAddonType)}>
        {sheets.map((sheet) => (
          <div key={sheet.addon.id} className={styles.itemWrapper}>
            <div className={styles.previewWrapper}>
              <div className={cn(styles.squareBgWrapper, styles.grayBg)}>
                <DisplayableSheet sheet={sheet} />
              </div>
            </div>
            <div className={styles.addonInfoWrapper}>
              <div>
                <div className={styles.addonInfoInnerWrapper}>
                  <p>{sheet.imageType.name.replace('Sibling ', '').trim()}</p>
                  <ItemSubtitle price={sheet.addon.priceWithout} addon={sheet.addon} offer={offer} />
                </div>
                <span style={{ fontStyle: 'italic', fontSize: '.9rem', color: '#888' }}>{sheet.addon.description}</span>
                <br />
                <span style={{ fontSize: '1.1rem' }}>{sheet.addon.tagline}</span>
              </div>
              <IncrementalButton
                initialCount={printBuilderCart[sheet.addon.id] || 0}
                className={styles.btnsWrapper}
                onDecrement={() => handleDecrement(sheet.addon.id)}
                onIncrement={() => handleIncrement(sheet.addon.id)}
                maxValue={sheet.addon.quantity && 1}
                quantity={sheet.addon.quantity}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={cn(styles.customizeBtnWrapper, { [styles.cancelBtn]: displayCancelButton })}>
        {/*<Button disabled={!hasMadeSelection} onClick={handleConfirm}>{`Update (${totalItems} items)`}</Button>*/}
        <div style={{ margin: '0 auto' }}>
          <Button disabled={!hasMadeSelection || isLoading} onClick={handleConfirm}>{continueText(addons[0])}</Button>
          {true && (
            <Button onClick={onCancelProps.onClick}>
              {onCancelProps.text || 'Continue to Checkout'}
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
